import { render, staticRenderFns } from "./NewSocialNetworks.vue?vue&type=template&id=1936246b"
import script from "./NewSocialNetworks.vue?vue&type=script&lang=js"
export * from "./NewSocialNetworks.vue?vue&type=script&lang=js"
import style0 from "./NewSocialNetworks.vue?vue&type=style&index=0&id=1936246b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports